import { h$1 as h, p as m, Y as u, h as k, a as A, me as $, m as w, o as C } from "../chunks/register-Ba9sFUKZ.js";
import * as B from "react";
import { u as I } from "../chunks/class-map-B8OdeXIO.js";
import { o as x } from "../chunks/unsafe-svg-CXadf7rM.js";
import { v as H } from "../chunks/mixin-CP6jLr_x.js";
import { h as S, d as z } from "../chunks/lifecycle-decorators-C04d1yHY.js";
import { A as y, q as f } from "../chunks/query-assigned-DFc_RnLg.js";
const O = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
<path d="M16 10L12 14L8 10" stroke="var(--accordion-chevron-color)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`, v = {
  beaconTagName: "beacon-accordion-item"
}, T = h`[beacon-tag-name=beacon-accordion-item] [slot=icon]{block-size:var(--accordion-icon-column-size);inline-size:var(--accordion-icon-column-size)}[beacon-tag-name=beacon-accordion-item] [slot=title]{--accordion-item-title-margin-inline-start: calc(var(--accordion-icon-column-size) + var(--beacon-reference-space-4))}[beacon-tag-name=beacon-accordion-item] [slot=icon]~[slot=title]{--accordion-item-title-margin-inline-start: 0}`, D = h`:host([motion-state=enabled]) :is(summary){transition-duration:var(--beacon-reference-motion-duration-3);transition-property:background-color;transition-timing-function:var(--beacon-system-motion-easing-decelerate-emphasize-1)}`;
var M = (n, a, t, o) => {
  for (var e = a, i = n.length - 1, s; i >= 0; i--)
    (s = n[i]) && (e = s(e) || e);
  return e;
};
const p = "cubic-bezier(0.05,0.7,0.1,1)", g = 50, b = 150;
function N(n) {
  let a = class extends n {
    constructor() {
      super(...arguments), this.isClosing = !1, this.isOpening = !1;
    }
    static get AccordionItemMotionStyles() {
      return [D];
    }
    get detailsElement() {
      var t;
      return (t = this.shadowRoot) == null ? void 0 : t.querySelector("details");
    }
    get summaryElement() {
      var t;
      return (t = this.shadowRoot) == null ? void 0 : t.querySelector("summary");
    }
    get panelElement() {
      var t;
      return (t = this.shadowRoot) == null ? void 0 : t.querySelector(
        "details > .accordion-grid"
      );
    }
    /**
     * Calls custom open and collapse methods that manage open state and animations on the `<details>` element
     */
    summaryClickHandler(t) {
      var o, e, i;
      this.getAttribute("motion-state") !== "disabled" && (t.preventDefault(), (o = this.detailsElement) == null || o.style.setProperty("overflow", "hidden"), this.isClosing || !((e = this.detailsElement) != null && e.hasAttribute("open")) ? this.openDetails() : (this.isOpening || (i = this.detailsElement) != null && i.hasAttribute("open")) && this.collapse());
    }
    /**
     * Handles animation of accordion item when it is collapsing
     */
    collapse() {
      var t, o, e;
      this.isClosing = !0;
      const i = `${(t = this.detailsElement) == null ? void 0 : t.offsetHeight}px`, s = `${(o = this.summaryElement) == null ? void 0 : o.offsetHeight}px`;
      this.animation && this.animation.cancel(), this.animation = (e = this.detailsElement) == null ? void 0 : e.animate(
        {
          // Set the keyframes from the startHeight to endHeight
          height: [i, s]
        },
        {
          delay: g,
          duration: b,
          easing: p
        }
      ), this.animation && (this.animation.onfinish = () => this.onAnimationFinish(!1)), this.animation && (this.animation.oncancel = () => this.isClosing = !1);
    }
    /**
     * Sets open attribute on `<details>` element and set's block-size to current height of `<details>` element in order for animations to occur
     */
    openDetails() {
      var t, o, e;
      (o = this.detailsElement) == null || o.style.setProperty(
        "block-size",
        `${(t = this.detailsElement) == null ? void 0 : t.offsetHeight}px`
      ), (e = this.detailsElement) == null || e.setAttribute("open", ""), window.requestAnimationFrame(() => this.expandDetails());
    }
    /**
     * Handles animation of accordion item when it is expanding
     */
    expandDetails() {
      var t, o, e, i;
      this.isOpening = !0;
      const s = `${(t = this.detailsElement) == null ? void 0 : t.offsetHeight}px`, E = `${((o = this.summaryElement) == null ? void 0 : o.offsetHeight) + ((e = this.panelElement) == null ? void 0 : e.offsetHeight)}px`;
      this.animation && this.animation.cancel(), this.animation = (i = this.detailsElement) == null ? void 0 : i.animate(
        {
          // Set the keyframes from the startHeight to endHeight
          height: [s, E]
        },
        {
          delay: g,
          duration: b,
          easing: p
        }
      ), this.animation && (this.animation.onfinish = () => this.onAnimationFinish(!0)), this.animation && (this.animation.oncancel = () => this.isOpening = !1);
    }
    /**
     * Handles state of `<details>` element after expand/collapse animations have ocurred and resets animation state of component
     */
    onAnimationFinish(t) {
      var o, e, i, s;
      t ? (o = this.detailsElement) == null || o.setAttribute("open", "") : (e = this.detailsElement) == null || e.removeAttribute("open"), this.animation = void 0, this.isClosing = !1, this.isOpening = !1, (i = this.detailsElement) == null || i.style.setProperty("overflow", ""), (s = this.detailsElement) == null || s.style.setProperty("block-size", "");
    }
  };
  return a = M([
    S("AccordionItemMotion")
  ], a), a;
}
const P = h`:host{--accordion-chevron-color: var(--beacon-system-color-icon-secondary)}.accordion-grid{align-items:center;display:grid;grid-template-areas:"icon content chevron";grid-template-columns:auto 1fr auto;padding-block:var(--accordion-item-grid-space-padding-block);padding-inline-start:var(--beacon-reference-space-3)}.title{font:var(--accordion-item-title-font);margin-inline-end:var(--beacon-reference-space-4);padding-block:var(--accordion-item-title-space-padding-block)}::slotted([slot=title]){margin-inline-start:var(--accordion-item-title-margin-inline-start, initial)}details{color:var(--beacon-system-color-text-standard)}[open] summary{background:var(--beacon-system-color-background-secondary-hover)}[open] summary:active{background:var(--beacon-system-color-background-secondary-pressed)}[open] .chevron{transform:rotate(180deg)}summary{border-inline-start:var(--beacon-system-width-border-normal) solid transparent;cursor:pointer;list-style:none}summary:hover{--accordion-chevron-color: var(--beacon-system-color-icon-secondary-hover);background:var(--beacon-system-color-background-secondary-hover);border-inline-start:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-link)}summary:active{--accordion-chevron-color: var(--beacon-system-color-icon-secondary-pressed);background:var(--beacon-system-color-background-secondary-pressed)}summary::-webkit-details-marker{display:none}.icon{grid-area:icon;margin-inline-end:var(--beacon-reference-space-4)}.chevron{align-self:start;display:flex;grid-area:chevron;margin-inline-start:auto;padding:var(--beacon-reference-space-3);transform:rotate(0);transition-duration:var(--beacon-reference-motion-duration-3);transition-property:transform}.panel{font:var(--accordion-item-panel-font);grid-area:content;margin-inline:calc(var(--accordion-icon-column-size) + var(--beacon-reference-space-4)) var(--beacon-reference-space-10);padding-block:var(--beacon-reference-space-3)}.hide{display:none}`;
var R = Object.defineProperty, q = Object.getOwnPropertyDescriptor, c = (n, a, t, o) => {
  for (var e = o > 1 ? void 0 : o ? q(a, t) : a, i = n.length - 1, s; i >= 0; i--)
    (s = n[i]) && (e = (o ? s(a, t, e) : s(e)) || e);
  return o && e && R(a, t, e), e;
}, l;
const r = (l = class extends H($).with(
  N
) {
  constructor() {
    super(...arguments), this.beaconTagName = v.beaconTagName, this.deferrable = !1, this.open = !1, this.hasIcon = !1;
  }
  static get styles() {
    return [super.styles, P, this.AccordionItemMotionStyles];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, T];
  }
  /**
   * Sets the `open` property based on the `open` attribute of the `<details>` element
   * and emits the state of the accordion-item after being toggled
   */
  toggleEventHandler() {
    this.open = this.details.hasAttribute("open"), this.emitToggle();
  }
  /**
   * Emits a beacon-event-click to be used by parent `<accordion>` component to manage state on single-open mode
   */
  clickEventHandler() {
    this.emitClick();
  }
  iconSlotChange() {
    var n;
    this.hasIcon = !!((n = this.slottedIcon) != null && n.length), l.addAnalyticsAttributes(
      this.slottedIcon.find((a) => typeof a < "u")
    );
  }
  titleSlotChange() {
    const n = this.slottedTitle.find(
      (a) => typeof a < "u"
    );
    l.addAnalyticsAttributes(n), n.textContent && this.summary.setAttribute(
      m.TEXT,
      n.textContent
    );
  }
  renderIcon() {
    const n = {
      icon: !0,
      hide: !this.hasIcon
    };
    return u`<div class=${I(n)}>
      <slot @slotchange=${this.iconSlotChange} name="icon"></slot>
    </div>`;
  }
  /**
   * Analytics attributes added to the `<summary>`, slotted in icon and slotted title element for analytics to capture tracking
   */
  static addAnalyticsAttributes(n) {
    n && (n.setAttribute(m.TYPE, "EC"), n.setAttribute(m.CLICKABLE, "true"));
  }
  addAnalytics() {
    l.addAnalyticsAttributes(this.summary);
  }
  render() {
    return u`
      <details
        @click=${this.clickEventHandler}
        @toggle=${this.toggleEventHandler}
        ?open=${this.open}>
        <summary @click=${this.summaryClickHandler}>
          <div class="accordion-grid">
            ${this.renderIcon()}
            <div class="title">
              <slot @slotchange=${this.titleSlotChange} name="title"></slot>
            </div>
            <div class="chevron">${x(O)}</div>
          </div>
        </summary>
        <div class="accordion-grid">
          <div class="panel">
            <slot name="panel"></slot>
          </div>
        </div>
      </details>
    `;
  }
}, l.tagName = v.beaconTagName, l);
c([
  k({ type: Boolean, reflect: !0 })
], r.prototype, "open", 2);
c([
  y("details")
], r.prototype, "details", 2);
c([
  y("summary")
], r.prototype, "summary", 2);
c([
  A()
], r.prototype, "hasIcon", 2);
c([
  f({ flatten: !0, slot: "icon" })
], r.prototype, "slottedIcon", 2);
c([
  f({ flatten: !0, slot: "title" })
], r.prototype, "slottedTitle", 2);
c([
  z
], r.prototype, "addAnalytics", 1);
let d = r;
const Z = (n) => (w(n, d), C({
  tagName: n ? n + "-" + d.tagName : d.tagName,
  elementClass: d,
  react: B,
  events: {
    onBeaconEventRenderActionZone: "beacon-event-render-action-zone",
    onBeaconEventInput: "beacon-event-input",
    onBeaconEventChange: "beacon-event-change",
    onBeaconEventFocus: "beacon-event-focus",
    onBeaconEventBlur: "beacon-event-blur",
    onBeaconEventClick: "beacon-event-click",
    onBeaconEventMousedown: "beacon-event-mousedown",
    onBeaconEventKeydown: "beacon-event-keydown",
    onBeaconEventRender: "beacon-event-render",
    onBeaconEventDeferredChild: "beacon-event-deferred-child",
    onBeaconEventMouseenter: "beacon-event-mouseenter",
    onBeaconEventMouseleave: "beacon-event-mouseleave",
    onBeaconEventHide: "beacon-event-hide"
  }
}));
export {
  Z as default,
  Z as reactBeaconAccordionItem
};
